<script>
import { Bar, mixins } from 'vue-chartjs'

export default {
  extends: Bar,
  name: 'ReactiveChartBar',
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options', 'height'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
